import React, { PureComponent } from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {fetchCreditLimit, fetchCreditLine} from '../../CreditLimit/actions';
import {fetchUpcomingPayments} from '../../loans/actions';
import Layout from '../../shared/components/layouts/MainLayout';
import HeaderNotificationsNav from '../components/HeaderNotificationsNav';
import TradeDocuments from '../components/TradeDocuments';
import OverdueCard from "../../home/components/OverdueCard";
import UnlockLockBar from '../components/UnlockLockBar';
import notifications from '../../../assets/images/notifications.png';
import UnlockSoon from '../components/UnlockSoon';
import {TrackEventName} from '../../shared/constants/SegmentEvents';
import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {setSourceRoute} from '../../shared/actions';
import UnlockLater from '../../CreditLimit/components/utilization/UnlockLater';
import PreApprovalOnboarded from '../components/PreApprovalOnboarded';
import {CustomerStatus, evaluateStatus} from '../../home/misc/CustomerStatus';
import { PaymentStatus } from '../../shared/utils/PaymentStatus';

class ApplyNow extends PureComponent {
  componentDidMount() {
    this.props.fetchCreditLimit();
    this.props.fetchCreditLine();
    this.props.fetchUpcomingPayments();
  }

  redirectTo = path => {
    if (this.props.location.pathname !== path) this.props.setSource(this.props.location.pathname);
    this.props.push(path);
  }

  trackSegmentClick(text) {
    let eventName;

    switch(text) {
      case 'notifications':
        eventName = TrackEventName.NOTIFICATIONS_BELL_CLICKED;
        break;
      case 'upload_invoice':
        eventName = TrackEventName.NAVBAR_APPLY_UPLOAD_INVOICE_CLICKED;
        break;
      case 'upload_po':
        eventName = TrackEventName.NAVBAR_APPLY_UPLOAD_PO_CLICKED;
        break;
      default:
        eventName = null;
        break;
    };

    segmentEventTracker.trackEvent(eventName);
  }

  getRemainingDaysToUnlock() {
    const {expected_unlock_date} = this.props.creditLimit;
    const dateToday = moment().startOf('day');
    const dueDate   = moment(expected_unlock_date, "YYYY-MM-DD");
    return dueDate.diff(dateToday, 'days');
  }

  get isNegativeAvailableCreditLimit() {
    const {credit_remaining} = this.props.creditLimit;
    const isNumberNegative   = -1;

    return Math.sign(credit_remaining) === isNumberNegative;
  }

  get creditRemaining() {
    return this.isNegativeAvailableCreditLimit ? 0 : this.props.creditLimit.credit_remaining;
  }

  get overduePayments() {
    const filters = [PaymentStatus.OVERDUE]
    const {upcomingPayments = []} = this.props
    return upcomingPayments
            .filter(loanPlan => filters.includes(loanPlan.status))
            .filter(loanPlan => loanPlan.payment.total > 0)
  }

  renderOverdueCard = () => {
    let defaultProps = {
      overdueRepayments: this.overduePayments
    }

    defaultProps = {
      ...defaultProps,
      callToActionCopy: 'Contact Us',
      callToActionUrl: 'mailto:support@firstcircle.com',
      headingSubCopy: 'Contact us to settle your payment immediately to avoid more late fees.',
      footerCopy: '*This amount does not include additional fees yet. Contact us to know the exact amount you need to pay.',
      showId: false,
      showOverdueCount: false,
      showTableHeaders: false,
      showViewAllButton: true,
      sortById: false,
    }

    return (<OverdueCard {...defaultProps} />)
  }

  getMainComponent(component) {
    const {expected_unlock_date} = this.props.creditLimit;
    const {
      end_timestamp, 
      upcoming_rcl_start_timestamp
    } = this.props.creditLine;

    switch(component) {
      case 'overdue_payments_component':
        return this.renderOverdueCard();
      case 'trade_doc_upload_component':
        return (<TradeDocuments
                  creditRemaining={this.creditRemaining}
                  hasOverdue={this.hasOverdue()}
                  loading={this.props.loading}
                  trackClick={this.trackSegmentClick}
                  redirectTo={this.redirectTo}
                  endTimestamp={end_timestamp}
                  upcomingRclTimestamp={upcoming_rcl_start_timestamp}
               />);
      case 'soon_component':
        return (<UnlockSoon
          unlockDate={moment(expected_unlock_date).toDate()}
          redirectTo={this.redirectTo}
        />);
      case 'unlock_later_component':
        return <UnlockLater unlockDate={expected_unlock_date} />;
      case 'pre_approval':
        return (
          <PreApprovalOnboarded
            trackClick={this.trackSegmentClick}
            redirectTo={this.redirectTo}
            user={this.props.user}
          />
        );
      default:
        break;
    };
  }

  displayMainComponent() {
    const {overdue_count,is_credit_limit_locked} = this.props.creditLimit;
    const daysRemaining = this.getRemainingDaysToUnlock();
    if(this.isOnboarded()) return this.getMainComponent('pre_approval');
    if(!is_credit_limit_locked) return this.getMainComponent('trade_doc_upload_component');
    if(overdue_count > 0) return this.getMainComponent('overdue_payments_component');
    if(daysRemaining <= 5) return this.getMainComponent('soon_component');
    if(daysRemaining > 5) return this.getMainComponent('unlock_later_component');
    return null;
  }

  handleNotificationsClick = () => {
    this.trackSegmentClick('notifications');
    this.redirectTo('/notifications')
  }

  isOnboarded = () => {
    const customerStatus = evaluateStatus(this.props.user);

    return customerStatus === CustomerStatus.Onboarded ||
      customerStatus === CustomerStatus.OnboardedAndTradeDocSubmitted;
  }

  hasOverdue = () => {
    const {overdue_count} = this.props.creditLimit;
    return overdue_count > 0;
  }

  isCreditLimitLocked = () => {
    return this.props.creditLimit.is_credit_limit_locked;
  }

  isCreditLimitNotLockedAndHasOverduePayments = () => {
    return !this.isCreditLimitLocked() || this.hasOverdue() || this.isOnboarded();
  }

  isNegativeAmount = (amount) => { return amount < 0 }

  renderUnlockLockBar = () => {
    const {expected_unlock_date, amount_to_paydown_with_interest, amount_balance_outstanding} = this.props.creditLimit;

    if (this.isCreditLimitNotLockedAndHasOverduePayments()) return;
    if (this.isNegativeAmount(amount_balance_outstanding)) return;
    return (
      <UnlockLockBar
        unlockDate={expected_unlock_date}
        amountToPayDownWithInterest={amount_to_paydown_with_interest}
        outstandingPrincipalWithInterest={amount_balance_outstanding}
      />
    );
  }

  render() {
    return (
      <Layout gridClassName='_marginTop--xxlarge-tabletUp --narrow'>
        <HeaderNotificationsNav
          isOnboardingFinished={this.props.user.onboarding_finished}
          hasUnreadNotifications={this.props.unreadNotifications}
          imageUrl={notifications}
          onClick={this.handleNotificationsClick}
        />
        {this.displayMainComponent()}
        {this.renderUnlockLockBar()}
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    user:                state.user,
    loading:             state.shared.ui.loading.creditLimit,
    creditLimit:         state.creditLimit,
    creditLine:          state.creditLine,
    unreadNotifications: state.notifications.unreadNotifications,
    upcomingPayments:    state.loans.upcomingPayments,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    push:                  url => dispatch(push(url)),
    setSource:             url => dispatch(setSourceRoute(url)),
    fetchCreditLimit:      () => dispatch(fetchCreditLimit()),
    fetchCreditLine:       () => dispatch(fetchCreditLine()),
    fetchUpcomingPayments: () => dispatch(fetchUpcomingPayments()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplyNow);



// WEBPACK FOOTER //
// ./src/features/applyNow/containers/ApplyNow.js